import { useEffect, useState, memo } from "react";
import "../styles/Shopbycategory.css";
import { Link } from "react-router-dom";
import API from "../../../app/api";

function ShopbyCategory() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await API.get("banners/shop-by-category");
        const data = response.data;
        if (data.success && data.data) {
          setCategories(data.data);
        } else {
          setError("No categories found");
        }
      } catch (err) {
        console.error("Error fetching shop-by-category:", err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>Error: {error}</p>;
  const getCategory = (index) => categories[index] || {};

     // Agar API no data section hide  

  if (!categories || categories.length === 0) {
    return null;
  }

  return (

    <section className="Offer-Section">
      <div className="container">
        <div style={{ textAlign: "center", width: "100%" }}>
          <h1>SHOP BY CATEGORY</h1>
          {/* <p className="P001">Find what you love, sorted just for you.</p> */}
        </div>
      </div>

      <div className="container">
        <div className="grid">
          {/* Card 1 */}

          <div className="card tall boxwidth">
            <img src={getCategory(0)?.media?.desktop} alt={getCategory(0)?.name} className="desktop" loading="lazy" />
            <img src={getCategory(0)?.media?.mobile} alt={getCategory(0)?.name} className="mobile" loading="lazy" />
            <div className="overlay padding001" style={{ textAlign: "left" }}>
              <h3 className="h3001 h30055" style={{ textAlign: "left" }}  dangerouslySetInnerHTML={{
                                    __html: getCategory(0)?.name?.replace(/\{\"\s*\"\}/g, " "),
                                }} />
              <button className="box-button-ratio"> <Link to={getCategory.actionLink} style={{ textDecoration:"none", color:"#000"}}>Shop Now</Link></button>
            </div>
          </div>

          {/* Left Column */}

          <div className="left">
            {/* Card 2 */}
            <div className="card m002">
              <img src={getCategory(1)?.media?.desktop} alt={getCategory(1)?.name} className="desktop" loading="lazy" />
              <img src={getCategory(1)?.media?.mobile} alt={getCategory(1)?.name} className="mobile" loading="lazy" />
              <div className="overlay padding002">
                <h3 className="h3002"  dangerouslySetInnerHTML={{
                                    __html: getCategory(1)?.name?.replace(/\{\"\s*\"\}/g, " "),
                                }} />
                <button className="box-button-ratio"> <Link to={getCategory.actionLink} style={{ textDecoration:"none", color:"#000"}}>Shop Now</Link></button>
              </div>
            </div>

            {/* Card 3 */}
            <div className="card">
              <img src={getCategory(2)?.media?.desktop} alt={getCategory(2)?.name} className="desktop" loading="lazy" />
              <img src={getCategory(2)?.media?.mobile} alt={getCategory(2)?.name} className="mobile" loading="lazy" />
              <div className="overlay padding003">
                <h3 className="h3003"  dangerouslySetInnerHTML={{
                                    __html: getCategory(2)?.name?.replace(/\{\"\s*\"\}/g, " "),
                                }} />
                <button className="box-button-ratio"><Link to={getCategory.actionLink} style={{ textDecoration:"none", color:"#000"}}>Shop Now</Link></button>
              </div>
            </div>
          </div>


          {/* Card 4 */}
          <div className="card mobile">
            <img src={getCategory(3)?.media?.desktop} alt={getCategory(3)?.name} className="desktop" loading="lazy" />
            <img src={getCategory(3)?.media?.mobile} alt={getCategory(3)?.name} className="mobile" loading="lazy" />
            <div className="overlay padding003">
              <h3 className="h3003" dangerouslySetInnerHTML={{
                                    __html: getCategory(3)?.name?.replace(/\{\"\s*\"\}/g, " "),
                                }} />
              <button className="box-button-ratio">Shop Now</button>
            </div>
          </div>

          {/* Card 5 (tall desktop) */}
          <div className="card tall desktop">
            <img src={getCategory(3)?.media?.desktop} alt={getCategory(3)?.name} className="desktop" loading="lazy" />
            <img src={getCategory(3)?.media?.mobile} alt={getCategory(3)?.name} className="mobile" loading="lazy" />
            <div className="overlay padding004" style={{ textAlign: "center" }}>
              <h3 className="h3004" dangerouslySetInnerHTML={{
                                    __html: getCategory(3)?.name?.replace(/\{\"\s*\"\}/g, " "),
                                }} />
              <button className="box-button-ratio"><Link to={getCategory.actionLink} style={{ textDecoration:"none", color:"#000"}}>Shop Now</Link></button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
export default memo(ShopbyCategory);